/**
 * Substracts value2 from value 1
 * @param value1 Substractable value
 * @param value2 Substractable value
 * @returns Substraction of values
 */
export function hbsHelperSub(value1: string, value2: string): number | Error {
  if (isNaN(parseFloat(value1)) || isNaN(parseFloat(value2))) {
    return new Error("Invalid values");
  }
  return parseFloat(value1) - parseFloat(value2);
}